import React from 'react';

import i18n from 'i18n-react';
import { HashLink as Link } from 'react-router-hash-link';

const ThankYouView = () => {
  const params = new URLSearchParams(window.location.search);
  let mobile = false;
  if (params.get('mobile')) {
    mobile = true;
  }

  return (
    <div className="thankYouView BookingForm">
      <div className="thankYouView__wrapper">
        <div className="thankYouView__wrapper--header">
          <h1>{i18n.translate('rewards.thankYouPage.thanks')}</h1>
        </div>
        <p>
          <b>{i18n.translate('rewards.thankYouPage.congrats')}</b>
          {i18n.translate('rewards.thankYouPage.body')}
          <br />
          <br />
          <Link to="/main/rewards/form">
            <button className="btn" type="button">
              {i18n.translate('rewards.menu.form')}
            </button>
          </Link>
        </p>
      </div>
      {mobile && (
        <style>
          {
            '\
    #CookiebotWidget { display: none !important; } .contentContainer { margin-top: 5rem; } .header { display: none; } .cookieConsent { display: none; } '
          }
          {'.thankYouView__wrapper { margin-top: 5rem !important; }'}
        </style>
      )}
    </div>
  );
};

export default ThankYouView;
